import { InteractiveMarker } from "common/Map/InteractiveMarker";
import { iconTypes } from "common/Map/Marker/iconTypes";
import { RouteLine } from "common/Map/RouteLine";
import { ProfileImg } from "common/ProfileImg";
import { LiveLog, Trip, User } from "data/records";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import styles from "./LiveLogLine.scss";

export class LiveLogLine extends React.PureComponent {
  static propTypes = {
    user: PropTypes.instanceOf(User).isRequired,
    trip: PropTypes.instanceOf(Trip).isRequired,
    liveLog: PropTypes.instanceOf(LiveLog).isRequired,
  };

  render() {
    const { liveLog, user, trip, showDistanceMarkers } = this.props;

    const lastPoint = trip.trackPoints.length > 0 && trip.trackPoints[trip.trackPoints.length - 1];
    const latlng = lastPoint.lat && lastPoint.lng ? `${lastPoint.lat.toFixed(5)}, ${lastPoint.lng.toFixed(5)}` : null;

    const hoveredPopup = (
      <div className={styles.UserPopup}>
        <div className={styles.profileImg}>
          <ProfileImg user={user} />
        </div>
        <div className={styles.content}>
          <div className={styles.username}>Live log position at</div>
          <div className={styles.meta}>{moment(liveLog.updatedAt).format("h:mm a")}</div>
          {latlng && <div className={styles.latlng}>{latlng}</div>}
        </div>
      </div>
    );

    const icon = iconTypes.liveLogIcon;
    const popupOffset = [0, -icon.iconSize[1] / 2];

    return (
      <React.Fragment>
        <RouteLine
          color="blue"
          route={trip}
          showStartMarker
          showEndMarker={false}
          showDistanceMarkers={showDistanceMarkers}
        />
        {lastPoint && (
          <InteractiveMarker
            id={`livelog-${user.id}`}
            position={lastPoint}
            icon={icon}
            popupOffset={popupOffset}
            hoveredPopup={hoveredPopup}
          />
        )}
      </React.Fragment>
    );
  }
}
